import React from 'react';
import { ShippingMode } from '../apis/dtos';
import SvgAir from '../assets/AirComponent';
import SvgBulk from '../assets/BulkComponent';
import SvgConsolidated from '../assets/ConsolidatedComponent';
import SvgFlatbed from '../assets/FlatbedComponent';
import SvgIntermodal from '../assets/IntermodalComponent';
import SvgLtl from '../assets/LessThanTruckloadComponent';
import SvgOcean from '../assets/OceanComponent';
import SvgSmallParcel from '../assets/SmallParcelComponent';
import SvgTruckload from '../assets/TruckloadComponent';

export const ModeSvg = (mode: ShippingMode, dataTestid?: string): React.JSX.Element => {
    switch (mode) {
      case ShippingMode.Truckload:
      case ShippingMode.Tautliner:
        return <SvgTruckload data-testid={dataTestid} />;
      case ShippingMode.LTL:
        return <SvgLtl data-testid={dataTestid} />;
      case ShippingMode.Intermodal:
        return <SvgIntermodal data-testid={dataTestid} />;
      case ShippingMode.Flatbed:
        return <SvgFlatbed data-testid={dataTestid} />;
      case ShippingMode.Bulk:
        return <SvgBulk data-testid={dataTestid} />;
      case ShippingMode.Air:
        return <SvgAir data-testid={dataTestid} />;
      case ShippingMode.Ocean:
        return <SvgOcean data-testid={dataTestid} />;
      case ShippingMode.Consolidated:
        return <SvgConsolidated data-testid={dataTestid} />;
      case ShippingMode.SmallParcel:
        return <SvgSmallParcel data-testid={dataTestid} />;
      default:
        return (<></>);
    }
  };
